import React, { useEffect, useState } from 'react';
import './Gallery.css';

// Helper to fetch local JSON files
async function fetchCategoryData(filename) {
  const res = await fetch(process.env.PUBLIC_URL + `/descriptions/${filename}`);
  return res.json();
}

export default function GalleryCategories({ language = 'en' }) {

  const [featuredByCategory, setFeaturedByCategory] = useState([]);
  const [allCollage, setAllCollage] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/descriptions/categories-manifest.json')
      .then(res => res.json())
      .then(async cats => {
        const featured = [];
        const collageImgs = [];
        for (const cat of cats) {
          const data = await fetchCategoryData(cat.filename);
          const featuredImg = data.find(item => item.isFeatured) || data[0];
          if (featuredImg) {
            featured.push({
              ...featuredImg,
              category: cat,
              categoryId: cat.id
            });
            collageImgs.push(process.env.PUBLIC_URL + '/' + (featuredImg.file || ''));
          }
        }
        setFeaturedByCategory(featured);
        // Build collage with all featured images, up to one per category
        setAllCollage(collageImgs);
      });
  }, []);

  return (
    <section className="gallery-section" id="gallery-categories">
      <div className="gallery-grid">
        {featuredByCategory.map((item, idx) => {
          const catId = item.categoryId;
          return (
            <div
              key={idx}
              className="gallery-card"
              style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
              role="button"
              tabIndex={0}
              onClick={() => window.location.hash = `#${catId}`}
              onKeyDown={e => { if (e.key === 'Enter') window.location.hash = `#${catId}`; }}
            >
              <img
                src={process.env.PUBLIC_URL + '/' + (item.file || '')}
                alt={(item.title && item.title[language]) || ''}
                className="gallery-img"
                style={{ objectFit: 'cover' }}
              />
              <div className="gallery-card-content" style={{
                width: '100%',
                background: '#0D5EAF',
                textAlign: 'center',
                padding: 4,
                borderRadius: '0 0 8px 8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 40
              }}>
                <h3 style={{ margin: 0, color: '#fff', fontWeight: 700, width: '100%' }}>{item.category.id === 'all' && language === 'pl' ? 'Wszystkie' : item.category.name[language]}</h3>
              </div>
            </div>
          );
        })}
        {/* All collage card at the end */}
        {allCollage && (
          <div
            className="gallery-card"
            style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: 0, height: '100%' }}
            role="button"
            tabIndex={0}
            onClick={() => {
              // Always show full gallery (not card grid)
              if (window.location.hash !== '#all') {
                window.location.hash = '#all';
              } else {
                // Force re-render if already on #all
                window.dispatchEvent(new HashChangeEvent('hashchange'));
              }
            }}
            onKeyDown={e => { if (e.key === 'Enter') window.location.hash = '#all'; }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gridAutoRows: '1fr',
                gap: 2,
                width: '100%',
                aspectRatio: '4/3',
                marginBottom: 0,
                minHeight: 180
              }}
            >
              {[...allCollage, ...allCollage.slice(0,4)].map((src, i) => (
                <img key={i}
                  src={src.replace(/(\.[a-zA-Z]+)$/, '-thumb$1')}
                  alt="Collage"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: 4,
                    display: 'block',
                  }}
                />
              ))}
            </div>
            <div className="gallery-card-content" style={{
              width: '100%',
              background: '#0D5EAF',
              textAlign: 'center',
              padding: 4,
              borderRadius: '0 0 8px 8px',
              marginTop: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 40
            }}>
              <h3 style={{ margin: 0, color: '#fff', fontWeight: 700, width: '100%' }}>{language === 'pl' ? 'Wszystkie' : 'All'}</h3>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
